import(/* webpackMode: "eager", webpackExports: ["MainPage"] */ "/builds/infra/front/marketing/blog-deploy-all/blog-next-vk-cloud-ru/blog-next/src/containers/MainPage/MainPage.tsx");
